type Language = {
	uuid: string;
	label: string;
	value: string;
};

export const languages: Language[] = [
	{
		uuid: "9e684df2-4d09-442a-901d-aa1be7bec385",
		label: "Afrikaans",
		value: "AFRIKAANS",
	},
	{
		uuid: "9e684df2-4d1d-4b31-bb30-78e40fa2cc96",
		label: "Albanian",
		value: "ALBANIAN",
	},
	{
		uuid: "9e684df2-4d23-407a-ace8-419024f311c1",
		label: "Amharic",
		value: "AMHARIC",
	},
	{
		uuid: "9e684df2-4d27-4695-b61c-7baa3b46b17c",
		label: "Arabic",
		value: "ARABIC",
	},
	{
		uuid: "9e684df2-4d2b-43ba-bbe3-c4c0f921512b",
		label: "Armenian",
		value: "ARMENIAN",
	},
	{
		uuid: "9e684df2-4d2e-445c-a168-88887c396697",
		label: "Basque",
		value: "BASQUE",
	},
	{
		uuid: "9e684df2-4d31-4e0f-b910-92a8c591874c",
		label: "Bengali",
		value: "BENGALI",
	},
	{
		uuid: "9e684df2-4d34-4a91-a663-73b461343b97",
		label: "Bosnian",
		value: "BOSNIAN",
	},
	{
		uuid: "9e684df2-4d36-498c-ba58-00da20a603aa",
		label: "Brazilian Portuguese",
		value: "BRAZILIAN PORTUGUESE",
	},
	{
		uuid: "9e684df2-4d39-4f44-9ac5-f40ce23a79d9",
		label: "Bulgarian",
		value: "BULGARIAN",
	},
	{
		uuid: "9e684df2-4d3d-4269-a2bf-694e68ed4cae",
		label: "Catalan",
		value: "CATALAN",
	},
	{
		uuid: "9e684df2-4d3f-474f-87a5-af8129dacf18",
		label: "Chinese (Mandarin)",
		value: "CHINESE (MANDARIN)",
	},
	{
		uuid: "9e684df2-4d42-412a-80ff-d4455b8b3bf2",
		label: "Croatian",
		value: "CROATIAN",
	},
	{
		uuid: "9e684df2-4d45-4de0-bf4e-4ca890cc4ad1",
		label: "Czech",
		value: "CZECH",
	},
	{
		uuid: "9e684df2-4d49-44eb-86b2-7a39fdafddff",
		label: "Danish",
		value: "DANISH",
	},
	{
		uuid: "9e684df2-4d4f-4773-ba45-d817d767d21c",
		label: "Dutch",
		value: "DUTCH",
	},
	{
		uuid: "9e684df2-4d52-4b0f-a52f-7aade4d3983e",
		label: "English",
		value: "ENGLISH",
	},
	{
		uuid: "9e684df2-4d55-427b-b54b-bd6b07c47c8f",
		label: "Estonian",
		value: "ESTONIAN",
	},
	{
		uuid: "9e684df2-4d57-48bd-a0a9-73958824598d",
		label: "Finnish",
		value: "FINNISH",
	},
	{
		uuid: "9e684df2-4d5a-4581-bcbd-9be1432ae77b",
		label: "French",
		value: "FRENCH",
	},
	{
		uuid: "9e684df2-4d5d-4520-a43a-c4fc41f7327a",
		label: "Georgian",
		value: "GEORGIAN",
	},
	{
		uuid: "9e684df2-4d61-48cf-8c99-756ea1d34d2f",
		label: "German",
		value: "GERMAN",
	},
	{
		uuid: "9e684df2-4d64-447e-a42f-3c8dd771a957",
		label: "Greek",
		value: "GREEK",
	},
	{
		uuid: "9e684df2-4d66-42ea-a5fc-5c8fa69206c5",
		label: "Gujarati",
		value: "GUJARATI",
	},
	{
		uuid: "9e684df2-4d69-454a-93e0-332afca6c228",
		label: "Haitian Creole",
		value: "HAITIAN CREOLE",
	},
	{
		uuid: "9e684df2-4d6b-46bb-85b0-48bc474ae979",
		label: "Hebrew",
		value: "HEBREW",
	},
	{
		uuid: "9e684df2-4d6e-4e8d-96aa-dd02689f5657",
		label: "Hindi",
		value: "HINDI",
	},
	{
		uuid: "9e684df2-4d70-45d3-9319-7d0a5ab5fbde",
		label: "Hungarian",
		value: "HUNGARIAN",
	},
	{
		uuid: "9e684df2-4d73-4f6b-91ad-6b36b07384a0",
		label: "Icelandic",
		value: "ICELANDIC",
	},
	{
		uuid: "9e684df2-4d75-4f92-9e69-195cb52edd7f",
		label: "Indonesian",
		value: "INDONESIAN",
	},
	{
		uuid: "9e684df2-4d77-40bb-8c60-742147f3d783",
		label: "Italian",
		value: "ITALIAN",
	},
	{
		uuid: "9e684df2-4d7a-4632-8dde-a201a3513f6b",
		label: "Japanese",
		value: "JAPANESE",
	},
	{
		uuid: "9e684df2-4d7c-4c8b-9ec4-9877bd80f0dc",
		label: "Kannada",
		value: "KANNADA",
	},
	{
		uuid: "9e684df2-4d7f-434a-b357-bbd93c69951c",
		label: "Kazakh",
		value: "KAZAKH",
	},
	{
		uuid: "9e684df2-4d81-42a3-93ae-0e2f09dbfbbc",
		label: "Khmer",
		value: "KHMER",
	},
	{
		uuid: "9e684df2-4d84-4645-935a-4b75ea42d5ec",
		label: "Korean",
		value: "KOREAN",
	},
	{
		uuid: "9e684df2-4d86-4729-a9f8-a09970c31cf8",
		label: "Latvian",
		value: "LATVIAN",
	},
	{
		uuid: "9e684df2-4d89-44ea-ae08-f89f05dbaba9",
		label: "Lithuanian",
		value: "LITHUANIAN",
	},
	{
		uuid: "9e684df2-4d8b-4e04-80ee-f88a70572b2f",
		label: "Macedonian",
		value: "MACEDONIAN",
	},
	{
		uuid: "9e684df2-4d8d-42d6-96f4-6a33b181cb71",
		label: "Malay",
		value: "MALAY",
	},
	{
		uuid: "9e684df2-4d8f-421e-9bfd-c083ac6f2ffb",
		label: "Malayalam",
		value: "MALAYALAM",
	},
	{
		uuid: "9e684df2-4d94-4ac4-85c6-ba66a2545f9f",
		label: "Marathi",
		value: "MARATHI",
	},
	{
		uuid: "9e684df2-4d97-454d-baf0-b0fe3b3edeed",
		label: "Mongolian",
		value: "MONGOLIAN",
	},
	{
		uuid: "9e684df2-4d99-4e0d-a860-31310a2792f1",
		label: "Nepali",
		value: "NEPALI",
	},
	{
		uuid: "9e684df2-4d9b-4dc3-8a77-c949e88b41b4",
		label: "Norwegian",
		value: "NORWEGIAN",
	},
	{
		uuid: "9e684df2-4da4-4380-8dc9-9ee7ac674ad8",
		label: "Pashto",
		value: "PASHTO",
	},
	{
		uuid: "9e684df2-4da8-4ef9-a1cf-b22bd93690ae",
		label: "Persian",
		value: "PERSIAN",
	},
	{
		uuid: "9e684df2-4daa-4dc8-9df0-c55203fbc18c",
		label: "Polish",
		value: "POLISH",
	},
	{
		uuid: "9e684df2-4dac-412b-a1aa-b71923e516f6",
		label: "Portuguese",
		value: "PORTUGUESE",
	},
	{
		uuid: "9e684df2-4dae-4b28-a680-fa2fbaa86696",
		label: "Punjabi",
		value: "PUNJABI",
	},
	{
		uuid: "9e684df2-4db2-48a4-8be0-ddd503857508",
		label: "Romanian",
		value: "ROMANIAN",
	},
	{
		uuid: "9e684df2-4db4-4ca4-aa1d-be9690f66ea0",
		label: "Russian",
		value: "RUSSIAN",
	},
	{
		uuid: "9e684df2-4db7-44f3-8ab3-7b84121163f8",
		label: "Serbian",
		value: "SERBIAN",
	},
	{
		uuid: "9e684df2-4dba-433d-be98-6c592b4de76d",
		label: "Sinhala",
		value: "SINHALA",
	},
	{
		uuid: "9e684df2-4dbd-4ab4-8f2f-84e1cd19f397",
		label: "Slovak",
		value: "SLOVAK",
	},
	{
		uuid: "9e684df2-4dc0-4d1e-947a-cc82cd93edc9",
		label: "Slovenian",
		value: "SLOVENIAN",
	},
	{
		uuid: "9e684df2-4dc2-4c31-b5ad-44946b48149b",
		label: "Spanish",
		value: "SPANISH",
	},
	{
		uuid: "9e684df2-4dc6-4891-a8b5-5be0737e134e",
		label: "Swahili",
		value: "SWAHILI",
	},
	{
		uuid: "9e684df2-4dc9-45bb-96bc-a2a22b5f55cd",
		label: "Swedish",
		value: "SWEDISH",
	},
	{
		uuid: "9e684df2-4dcc-453f-98e5-8d94a47b7a76",
		label: "Tagalog",
		value: "TAGALOG",
	},
	{
		uuid: "9e684df2-4dcf-4433-a420-4b9393c46879",
		label: "Tamil",
		value: "TAMIL",
	},
	{
		uuid: "9e684df2-4dd1-458a-9363-d7487f69abb6",
		label: "Telugu",
		value: "TELUGU",
	},
	{
		uuid: "9e684df2-4dd3-4897-8795-650445ead642",
		label: "Thai",
		value: "THAI",
	},
	{
		uuid: "9e684df2-4dd6-452f-aabc-9214635abba6",
		label: "Turkish",
		value: "TURKISH",
	},
	{
		uuid: "9e684df2-4dd8-4ef0-a591-c909005729e8",
		label: "Ukrainian",
		value: "UKRAINIAN",
	},
	{
		uuid: "9e684df2-4dda-4cae-ac55-3d0119b80cbc",
		label: "Urdu",
		value: "URDU",
	},
	{
		uuid: "9e684df2-4ddc-4951-98b3-10ebaf09deea",
		label: "Vietnamese",
		value: "VIETNAMESE",
	},
	{
		uuid: "9e684df2-4ddf-47a5-a2b6-c413ffa965ed",
		label: "Welsh",
		value: "WELSH",
	},
	{
		uuid: "9e684df2-4de1-41c2-9bb3-862e162f5ce2",
		label: "Xhosa",
		value: "XHOSA",
	},
	{
		uuid: "9e684df2-4de3-48ec-a4e3-afeeb751c666",
		label: "Yoruba",
		value: "YORUBA",
	},
	{
		uuid: "9e684df2-4de6-42b9-8ea0-d4203466e7b5",
		label: "Zulu",
		value: "ZULU",
	},
];
